import { defineStore } from 'pinia';

import { waitFor } from '@stuut/common/src/utils';

import { stuut } from '@/api';

interface State {
  flags: Record<string, any>;
  loaded: boolean;
  loadingFlags: boolean;
}

export const useFeatureFlags = defineStore('featureFlags', {
  actions: {
    async loadFeatureFlags() {
      // Flags are immutable for the session — fetch once and share the result
      // across every consumer so they resolve in lockstep instead of each
      // re-fetching and flipping on independent timelines.
      if (this.$state.loaded) return this.$state.flags;

      if (this.$state.loadingFlags) {
        await waitFor(() => !this.$state.loadingFlags, 100);
      } else {
        this.$patch({ loadingFlags: true });
        try {
          const flags = await stuut.getFeatureFlags();
          this.$patch({
            flags,
            loaded: true,
            loadingFlags: false,
          });
        } catch (error) {
          // Still mark loaded so consumers can proceed with default-off flags
          // (matches the old per-call ready.value = true after await).
          this.$patch({ loaded: true, loadingFlags: false });
        }
      }

      return this.$state.flags;
    },
    setFlag(flag: string, value: unknown) {
      this.flags[flag] = value;
    },
  },
  getters: {},
  state: (): State => ({
    flags: {},
    loadingFlags: false,
    loaded: false,
  }),
});
